var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"autoplay":"","loop":"","muted":"","width":_vm.width},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }